module.exports = __webpack_public_path__ + "static/media/texture_05.e1d7d1a7.png";